import { formatInTimeZone } from "date-fns-tz";
import { setStickyOffset } from "./js/utils";

document.addEventListener("DOMContentLoaded", () => {
	const masthead = document.querySelector("#masthead");
	const main = document.querySelector("#primary");
	const notify = document.querySelector("#banner-container");
	const alertsContainer = document.querySelector(".notify-notification-bar");
	const bannerTexts = document.querySelectorAll(".notify-text");
	const notifyClose = document.querySelector(".notify-close-button");
	const notifyToggle = document.querySelector(".notify-toggle-button");
	const notifyDisplayToggle = document.querySelector(".notify-display-toggle");
	const duration = parseInt(notify?.dataset.duration || "8000", 10);
	// --- Get current Pacific Time ---
	const currentDate = formatInTimeZone(
		new Date(),
		"America/Los_Angeles",
		"yyyy-MM-dd HH:mm:ss"
	);

	const alerts = window.krust?.alerts || [];
	if (alerts.length === 0) return;

	/**
 * 
 * 	<div
									class="notify-text"
									data-publish="<?php echo esc_attr($publish_on ? $publish_on->format('Y-m-d H:i:s T') : ''); ?>"
									data-unpublish="<?php echo esc_attr($unpublish_on ? $unpublish_on->format('Y-m-d H:i:s T') : ''); ?>"
									style="display:none;">
									<?php echo wp_kses_post($bannertxt); ?>&nbsp;<?php echo $cta_link; ?>
								</div>


 */

	const activeBanners = [];
	alerts.forEach((alert) => {
		const isAfterPublishStart =
			alert.publish_on === null || alert.publish_on <= currentDate;
		const isBeforePublishEnd =
			alert.unpublish_on === null || alert.unpublish_on > currentDate;

		if (isAfterPublishStart && isBeforePublishEnd) {
			console.log("adding", alert);
			const div = document.createElement("div");
			div.classList.add("notify-text");
			div.style.display = "none";
			const a = document.createElement("a");
			a.href = alert.cta_link.url;
			a.innerText = alert.cta_link.title;
			a.setAttribute("target", "_blank");
			div.innerText = `${alert.banner_message} `;
			div.appendChild(a);

			alertsContainer.appendChild(div);
			activeBanners.push(div);
		} else {
			console.log(
				"Not adding alert",
				alert,
				isAfterPublishStart,
				isBeforePublishEnd
			);
		}
	});

	notify.style.display = "";

	// --- Sticky masthead offset ---
	function addMastheadTop() {
		const height = document.body.classList.contains("logged-in")
			? notify.offsetHeight + 32
			: notify.offsetHeight;
		masthead.style.top = `${height}px`;
		main.style.paddingTop = `${notify.offsetHeight}px`;
		setStickyOffset(height);
	}

	function removeMastheadTop() {
		masthead.style.top = "";
		main.style.paddingTop = "";
		notify.style.height = "0";
		notify.style.transition = "height 0.5s ease";
	}

	notifyToggle?.addEventListener("click", removeMastheadTop);
	notifyDisplayToggle?.addEventListener("click", addMastheadTop);
	window.addEventListener("resize", addMastheadTop);

	// --- Banner rotation ---
	let currentIndex = 0;
	function showBannerText() {
		if (notify.offsetHeight > 0) {
			activeBanners.forEach((el) => (el.style.display = "none"));
			activeBanners[currentIndex].style.display = "block";
			currentIndex = (currentIndex + 1) % activeBanners.length;
			setTimeout(showBannerText, duration);
		}
	}

	// --- Initialize ---
	addMastheadTop();
	showBannerText();
});
